import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68ebdd6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ops" }
const _hoisted_2 = { class: "ops-left" }
const _hoisted_3 = { class: "ops-right" }

import {
  JuouProTable,
  JuouProTableColumn,
  JuouProTableData,
  JuouProTableFilter,
  JuouProTableGetDataFunction,
  JuouDangerDialog,
  JuouProForm,
  JuouProFormItem,
  useBaseAsync,
} from 'juou-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref, watchEffect } from 'vue';
import dayjs from 'dayjs';
import StoreDetail from '@/components/StoreDetail.vue';
import { useStore } from '@/store/store';
import { getTodaySec, todaySecToDayjs } from '@/utils';
import * as xlsx from 'xlsx';
import FileSaver from 'file-saver';


export default /*#__PURE__*/_defineComponent({
  __name: 'ticket',
  setup(__props, { expose: __expose }) {

const packageId = ref<number>();
const visible = ref(false);

const columns = ref<JuouProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof JuouProTable>>();
const store = useStore();

const bathUpdateDialogRef = ref<InstanceType<typeof JuouProForm>>();
const bathGenDialogRef = ref<InstanceType<typeof JuouProForm>>();
const genDialogRef = ref<InstanceType<typeof JuouProForm>>();

const addInitValue = {

};
const conditionsInitValue = {
};

const batchGenItems: JuouProFormItem[] = [
  {
    name: 'count',
    label: '数量',
    type: 'number',
    rule: [{ required: true }],
  },
  {
    name: 'expireAt',
    label: '过期时间',
    type: 'datepick',
    pickType: 'datetime',
  },
];

const batchGenInitValue = {
  count: 1,
  expireAt: undefined,
};

const batchUpdateItems: JuouProFormItem[] = [
  {
    name: 'used',
    label: '是否核销',
    type: 'swtich',
    rule: [{ required: true }],
  },
  {
    name: 'expireAt',
    label: '过期时间',
    type: 'datepick',
    pickType: 'datetime',
  },
];


const genItems: JuouProFormItem[] = [
  {
    name: 'phone',
    label: '客户手机号',
    type: 'numberStr',
    rule: [{ required: true }],
  },
  {
    name: 'expireAt',
    label: '过期时间',
    type: 'datepick',
    pickType: 'datetime',
  },
];


const genInitValue = {
  phone: undefined,
  expireAt: undefined,
};

const currentSelectTickets = ref<any[]>([]);

const batchOperates = [
  {
    name: '批量修改',
    key: 'batUpdate',
    handler: (rows: any[]) => {
      console.log(rows);
      currentSelectTickets.value = rows;
      bathUpdateDialogRef.value?.setFormState({
        used: false,
        expireAt: undefined,
      });
      bathUpdateDialogRef.value?.showDialog();
    },
  },
];
// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(() => {
  columns.value = [
    {
      name: 'id',
      label: '券码',
      type: 'numberStr',
      isCondition: true,
    },
    {
      name: 'used',
      label: '是否核销',
      type: 'swtich',
      isCondition: true,
      width: 80,
    },
    {
      name: 'phone',
      label: '手机号',
      type: 'numberStr',
      isCondition: true,
    },

    {
      name: 'expireAt',
      label: '过期时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      render: ({ row }: any) => (row.expireAt ? dayjs(row.expireAt).format('YYYY年MM月DD日 HH:mm:ss') : '-'),

    },

    {
      name: 'createTime',
      label: '创建时间',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
      render: ({ row }: any) => dayjs(row.createTime).format('YYYY年MM月DD日 HH:mm:ss'),

    },

  ];
});


const operates: any[] = [];

const loading = ref(false);


const getData = useBaseAsync<JuouProTableGetDataFunction>(async(filter: JuouProTableFilter) => {
  if (!packageId.value) {
    return {
      total: 0,
      data: [],
    };
  }
  try {
    loading.value = true;
    const res = await useApi().hourPackageApi.pageHourTicketHourPackage({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {
        packageId: packageId.value,
      } as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: JuouProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.name})操作，请谨慎操作`;

// 批量修改小时券
const batchUpdateHourTicket = useBaseAsync(async(data: any) => {
  if (!packageId.value) {
    ElMessage.error('未选择小时券');
    return;
  }
  if (!currentSelectTickets.value.length) {
    ElMessage.error('至少选择一个小时券');
    return;
  }
  await useApi().hourPackageApi.batchUpdateTicketHourPackage({
    ticketIds: currentSelectTickets.value.map((item) => item.id),
    expireAt: data.expireAt && dayjs(data.expireAt).toDate(),
  });
  ElMessage.success('修改成功');
  tableRef.value?.refresh();
});

// 批量生成小时券
const batchGeneratorHourTicket = useBaseAsync(async(data: any) => {
  if (!packageId.value) {
    ElMessage.error('未选择小时券');
    return;
  }
  await useApi().hourPackageApi.batchGeneratorHourTicketHourPackage({
    ...data,
    packageId: packageId.value,
    expireAt: data.expireAt && dayjs(data.expireAt).toDate(),
  });
  ElMessage.success('生成成功');
  tableRef.value?.refresh();
});

// 发放小时券
const generatorHourTicket = useBaseAsync(async(data: any) => {
  if (!packageId.value) {
    ElMessage.error('未选择小时券');
    return;
  }
  await useApi().hourPackageApi.generatorHourTicketHourPackage({
    ...data,
    packageId: packageId.value,
    expireAt: data.expireAt && dayjs(data.expireAt).toDate(),
  });
  ElMessage.success('生成成功');
  tableRef.value?.refresh();
});


const handleExcel = useBaseAsync(async() => {
  if (!packageId.value) {
    ElMessage.error('未选择小时券');
    return;
  }
  const res = await useApi().hourPackageApi.listHourTicketHourPackage({
    conditions: Object.entries(tableRef.value?.filter?.conditions || {}).reduce((conditions, [key, val]) => {
      if (val === null || val === undefined || val === '') {
        return conditions;
      }
      conditions[key] = val;
      return conditions;
    }, {
      packageId: packageId.value,
    } as any),
  });
  console.log(res.data.data);
  const worksheet = xlsx.utils.json_to_sheet(res.data.data.map((item: any) => ({
    券码: String(item.id),
    是否核销: item.used ? '是' : '否',
    手机号: String(item.phone || ''),
    过期时间: item.expireAt ? dayjs(item.expireAt).format('YYYY-MM-DD HH:mm:ss') : '-',
    创建时间: dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
  })));
  const workbook = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(workbook, worksheet, 'Dates');
  const wbout = xlsx.write(workbook, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array',
  });
  try {
    FileSaver.saveAs(
      new Blob([wbout], {
        type: 'application/octet-stream',
      }),
      '小时券.xlsx',
    );
  } catch (error) {
    if (typeof console !== 'undefined') {
      console.log(error, wbout);
    }
  }
});


init();


__expose({
  show: (_packageId: number) => {
    packageId.value = _packageId;
    visible.value = true;
  },
});


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    width: "1100",
    title: "查看小时券",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    draggable: ""
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_unref(JuouProTable), {
            key: 0,
            ref_key: "tableRef",
            ref: tableRef,
            paginations: { pageSize: 10 },
            columns: columns.value,
            "get-data": _unref(getData),
            loading: loading.value,
            "is-dangder-delete": true,
            "format-dangder-delete-info": formatDeleteInfo,
            "row-key": "id",
            operates: operates,
            "add-init-values": addInitValue,
            "codition-init-values": conditionsInitValue,
            selection: true,
            "batch-operates": batchOperates
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[0] || (_cache[0] = () => {bathGenDialogRef.value?.setFormState({...batchGenInitValue});bathGenDialogRef.value?.showDialog()})
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("批量生成小时券")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[1] || (_cache[1] = () => {genDialogRef.value?.setFormState({...genInitValue});genDialogRef.value?.showDialog()})
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("发放单个小时券")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _unref(handleExcel)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("导出小时券")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          }, 8, ["columns", "get-data", "loading"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(JuouProForm), {
        ref_key: "bathUpdateDialogRef",
        ref: bathUpdateDialogRef,
        title: "批量修改小时券",
        "on-ok": _unref(batchUpdateHourTicket),
        isDialog: true,
        items: batchUpdateItems
      }, null, 8, ["on-ok"]),
      _createVNode(_unref(JuouProForm), {
        ref_key: "bathGenDialogRef",
        ref: bathGenDialogRef,
        title: "批量生成小时券",
        "on-ok": _unref(batchGeneratorHourTicket),
        isDialog: true,
        items: batchGenItems,
        "init-form-value": batchGenInitValue
      }, null, 8, ["on-ok"]),
      _createVNode(_unref(JuouProForm), {
        ref_key: "genDialogRef",
        ref: genDialogRef,
        title: "发放小时券",
        "on-ok": _unref(generatorHourTicket),
        isDialog: true,
        items: genItems,
        "init-form-value": genInitValue
      }, null, 8, ["on-ok"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})